import { type AxiosRequestConfig, AxiosResponse, Method } from "axios";
import axiosInstance from "./axiosInstance";
import { IResponse } from "@/api/Types";

const respondSuccess = (response: AxiosResponse): IResponse => ({
  loadingIndicator: false,
  errorIndicator: false,
  status: response.status,
  headers: response.headers,
  data: response.data,
  raw: response
});

const respondFailure = ({ error }: any) => ({ loadingIndicator: false, errorIndicator: true, error });

const apiBase = async <T>(method: Method, url: string, config?: AxiosRequestConfig, data?: any): Promise<IResponse> => {
  try {
    const response: AxiosResponse<T> = await axiosInstance.request<T>({
      method: method,
      url: url,
      ...config,
      data: data
    });
    return respondSuccess(response);
  } catch (error: any) {
    return respondFailure({ error });
  }
};

export default apiBase;
